function wrapText(context, text, x, y, maxWidth, lineHeight) {
  const words = text.split(' ');
  let line = '';

  words.forEach((word, i) => {
    const testLine = line + word + ' ';
    const metrics = context.measureText(testLine);
    const testWidth = metrics.width;

    if (testWidth > 90 && i > 0) {
      context.fillText(line, x, y);
      line = `${word} `;
      y += lineHeight;
    } else {
      line = testLine;
    }
  });

  context.fillText(line, x, y);
}

function createRectangle(ctx, rectX) {
  ctx.fillStyle = 'white';
  ctx.beginPath();
  ctx.roundRect(rectX, 65, 110, 75, [8]);
  ctx.fill();
}

function calculateImagePositions(data) {
  const CANVAS_WIDTH = 624;
  let positions = {};

  if (data[3]) {
    positions = {
      imgX: [80, 80 + CANVAS_WIDTH / 4, 80 + (2 * CANVAS_WIDTH) / 4, 80 + (3 * CANVAS_WIDTH) / 4],
      rectX: [25, 181, 337, 493],
    };
  } else if (data[2]) {
    positions = {
      imgX: [106, 106 + CANVAS_WIDTH / 3, 106 + (2 * CANVAS_WIDTH) / 3],
      rectX: [51, 260, 467],
    };
  } else if (data[1]) {
    positions = {
      imgX: [200, 400],
      rectX: [145, 345],
    };
  }

  return positions;
}

function loadImage(src, crossOrigin = 'anonymous') {
  return new Promise((resolve) => {
    const image = new Image();
    image.crossOrigin = crossOrigin;
    image.src = src;
    image.onload = () => resolve(image);
  });
}

function drawImageWithText(ctx, image, imageConfig, textConfig, positions, index) {
  const { maxWidth, maxHeight, top } = imageConfig;
  const { font, letterSpacing, color, align, lineHeight, textTop, textMaxWidth } = textConfig;

  const ratio = Math.min(maxWidth / image.width, maxHeight / image.height);
  const imgLeft = positions.imgX[index] - (image.width * ratio) / 2;
  const imgTop = top - image.height * ratio;

  createRectangle(ctx, positions.rectX[index]);

  ctx.drawImage(image, imgLeft, imgTop, image.width * ratio, image.height * ratio);

  ctx.font = font;
  ctx.letterSpacing = letterSpacing;
  ctx.fillStyle = color;
  ctx.textAlign = align;

  wrapText(
    ctx,
    imageConfig.label,
    positions.imgX[index],
    imgTop + image.height * ratio + textTop,
    textMaxWidth,
    lineHeight
  );
}

async function processImages(ctx, data, positions) {
  const IMAGE_CONFIG = {
    maxHeight: 120,
    maxWidth: 104,
    top: 136,
  };

  const TEXT_CONFIG = {
    font: '12px Campton',
    letterSpacing: '0.2px',
    color: 'white',
    align: 'center',
    lineHeight: 14,
    textTop: 26,
    textMaxWidth: 86,
  };

  for (let i = 0; i < data.length; i++) {
    if (data[i]) {
      const image = await loadImage(data[i].picture);
      drawImageWithText(
        ctx,
        image,
        { ...IMAGE_CONFIG, label: data[i].label },
        TEXT_CONFIG,
        positions,
        i
      );
    }
  }
}

export default function generateSingleWalletImage(template, data) {
  return new Promise((resolve) => {
    const canvasElement = document.createElement('canvas');
    const ctx = canvasElement.getContext('2d');

    const CANVAS = {
      width: 624,
      height: 240,
    };

    const positions = calculateImagePositions(data);

    const templateImg = new Image();
    templateImg.src = template;

    templateImg.onload = async function () {
      canvasElement.width = CANVAS.width;
      canvasElement.height = CANVAS.height;

      ctx.drawImage(templateImg, 0, 0, CANVAS.width, CANVAS.height);

      if (!data[0]) {
        resolve('');
        return;
      }

      await processImages(ctx, data, positions);

      const res = canvasElement.toDataURL('image/png');
      resolve(res);
    };
  });
}
